import { ActionTypes, ISetCalcOverrideAction } from './CalcOverride.action-types';

export const setCalcOverride = (data: boolean): ISetCalcOverrideAction => ({
    type: ActionTypes.SET_CALCOVERRIDE,
    data
});
